import React, { Component } from "react";
import "../../../components/BankTransferForm.css";
import { ActiveBankDataSelector } from "../../../Data/FormConfig ";
class BankSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAccount: null,
      // เปลี่ยนมาใช้ BankDataSelector ที่ประกาศไว้ในไฟล์นี้
      bankData: ActiveBankDataSelector,
      dropdownOpen: false,
    };
    this.dropdownRef = React.createRef();
  }

  componentDidMount() {
    const { defaultValue } = this.props;
    if (defaultValue) {
      const initialBank = this.state.bankData.find(
        (bank) =>
          bank.bank_id === defaultValue?.banks?.bank_id ||
          bank.bankCode === defaultValue?.banks?.scb_code ||
          bank.bankCode === defaultValue?.bankCode // กรณี defaultValue มาในโครงสร้างตรงๆ
      );

      if (initialBank) {
        this.setState({
          selectedAccount: initialBank,
        });
      }
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    // ลบ Event Listener เมื่อคอมโพเนนต์ถูกถอดออก
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  handleClickOutside = (event) => {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ dropdownOpen: false });
    }
  };
  toggleDropdown = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  handleSelectAccount = (account) => {
    const { onChangBank } = this.props;
    if (onChangBank) {
      onChangBank(account);
    }
    this.setState({
      selectedAccount: account,
      dropdownOpen: false, // ปิด Dropdown หลังจากเลือก
    });
  };

  // ค้นหา URL โลโก้ธนาคารจาก bankCode หรือ bank_id
  getBankLogo = (codeOrId) => {
    let bank = this.state.bankData.find((b) => b.bankCode === codeOrId);
    if (!bank) {
      bank = this.state.bankData.find((b) => b.bank_id === codeOrId);
    }
    return bank ? bank.bankLogo : "";
  };

  render() {
    const { selectedAccount, bankData, dropdownOpen } = this.state;
    const { defaultValue, t } = this.props;

    return (
      <div className="bank-transfer-bank">
        <div className="custom-dropdown-wrapper">
          {" "}
          {/* เพิ่ม div เพื่อจัดกลุ่ม */}
          <div className="custom-dropdown" ref={this.dropdownRef}>
            <div className="dropdown-selected" style={{ padding: "6px 15px" }} onClick={this.toggleDropdown}>
              {selectedAccount ? (
                <>
                  <img
                    height={19}
                    src={this.getBankLogo(
                      selectedAccount.bankCode || selectedAccount.bank_id
                    )}
                    alt="Bank Logo"
                    className="bank-logo-small"
                  />
                  <span>{t(selectedAccount.bank_id)}</span>
                </>
              ) : t("Select")}
              <span className="dropdown-arrow"></span> {/* ไอคอนลูกศร */}
            </div>

            {dropdownOpen && (
              <div className="dropdown-options">
                {bankData.map((bank) => {

                  return <>{bank.status && <div
                    key={bank.bank_id} // ใช้ bank_id เป็น key
                    className={`dropdown-option ${selectedAccount && selectedAccount.bank_id === bank.bank_id ? "selected" : ""}`}
                    onClick={() => this.handleSelectAccount(bank)}
                  >
                    <img
                      src={this.getBankLogo(bank.bankCode)}
                      alt="Bank Logo"
                      className="bank-logo-small"
                    />
                    <span>
                      {t(bank.bank_id)}{" "}
                      {defaultValue &&
                        defaultValue.banks &&
                        bank.bank_id === defaultValue.banks.bank_id
                        ? "(current)"
                        : ""}
                    </span>
                  </div>}</>
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default BankSelector;
